"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADD_PRODUCTS_MODAL = void 0;
var ADD_PRODUCTS_MODAL = {
  ROW__MARKET_PRICE_PRODUCT: 'addProductsModal-tr-marketPriceProduct',
  ROW__PRICE_UNIT_PRODUCT: 'addProductsModal-tr-priceUnitDifferentFromSalesUnitProduct',
  ROW__PRODUCT: 'addProductsModal-tr-product',
  BUTTON__CONFIRM: 'addProductsModal-button-addProducts',
  BUTTON__CANCEL: 'addProductsModal-button-cancel',
  BUTTON__QUANTITY: 'addProductsModal-button',
  INPUT__SEARCH: 'addProductsModal-input-search',
  INPUT__PRODUCT_CHECKBOX: 'addProductsModal-input-productCheckbox'
};
exports.ADD_PRODUCTS_MODAL = ADD_PRODUCTS_MODAL;